import * as React from 'react';

export interface DragDropContextProviderProps {
  backend?: Function;
}

export default class DragDropContextProvider extends React.Component<DragDropContextProviderProps> {}
